import React, { createContext, useContext } from 'react';

/**
 * Context of the access-level dashboards (B4). Null outside one — the OE widgets use that to keep
 * their generic behaviour. Value shape: see `useRoleDashboardData` in roleDashboardWidgets.jsx.
 */
const RoleDashboardContext = createContext(null);

export function useRoleDashboard() {
  return useContext(RoleDashboardContext);
}

export function RoleDashboardProvider({ value, children }) {
  return <RoleDashboardContext.Provider value={value}>{children}</RoleDashboardContext.Provider>;
}

export default RoleDashboardContext;
